/**
 * Agent Plan Panel component.
 * Displays the plan generated by the AI agent.
 */

import React from 'react';
import type { AgentPlan } from '@excel-ai-studio/shared';
import { Card, CardHeader, CardPreview, Body1, Caption1 } from '@fluentui/react-components';

interface AgentPlanPanelProps {
  plan: AgentPlan;
}

export const AgentPlanPanel: React.FC<AgentPlanPanelProps> = ({ plan }) => {
  return (
    <div className="agent-plan-panel">
      <Card>
        <CardHeader
          header={<Body1 style={{ fontWeight: 600 }}>Plan généré</Body1>}
          description={<Caption1>Confiance: {(plan.confidence * 100).toFixed(0)}%</Caption1>}
        />
        <CardPreview>
          <div className="plan-content">
            <div className="plan-reasoning">
              <Caption1 style={{ fontWeight: 600 }}>Raisonnement:</Caption1>
              <Caption1>{plan.reasoning}</Caption1>
            </div>
            <div className="plan-steps">
              <Caption1 style={{ fontWeight: 600 }}>Étapes ({plan.steps.length}):</Caption1>
              <ul className="steps-list">
                {plan.steps.map((step, idx) => (
                  <li key={step.id} className="step-item">
                    <span className="step-number">{idx + 1}</span>
                    <span className="step-action">{step.action}</span>
                    <span className="step-description">{step.description}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </CardPreview>
      </Card>
    </div>
  );
};
